// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App'
import Partners from '@/components/partners'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import store from './store'
import TextareaAutosize from 'vue-textarea-autosize'
import LoadScript from 'vue-plugin-load-script'

Vue.use(LoadScript)
Vue.config.productionTip = false
Vue.use(VueLodash, { lodash: lodash })
Vue.use(TextareaAutosize)

const isPartnerApp = document.location.href.indexOf('/Partners') > 0
const components = !isPartnerApp ? { App } : { Partners }
const template = !isPartnerApp ? '<App/>' : '<Partners/>'

const main = async () => {
  const router = !isPartnerApp ? await import('./router') : await import('./components/partners/router')

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router: router.default,
    vuetify,
    store,
    components,
    template
  })
}
main()



// WEBPACK FOOTER //
// ./src/main.js